import { Headline } from '@oneaudi/unified-web-components';
import type { FC } from 'react';
import React, { useContext } from 'react';
import { FAStateContext } from '../context/FAStateContext';

export const CarName: FC = () => {
  const {
    carline: { name },
  } = useContext(FAStateContext);
  return (
    <Headline variant={{ order: '2', type: 'headline', weight: 'normal' }} tag="h2">
      {name}
    </Headline>
  );
};
